import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';

import {
    Carousel, CarouselItem, Image, Empty, Breadcrumb,
    BreadcrumbItem, Badge, Loading, MessageBox
} from 'element-ui'


Vue.prototype.$loading = Loading.service;
Vue.prototype.$prompt = MessageBox.prompt;

Vue.use(Loading.directive);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Image);
Vue.use(Empty);
Vue.use(BreadcrumbItem);
Vue.use(Breadcrumb);
Vue.use(Badge);